var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"share-network-list"},_vm._l((_vm.networks),function(n){return _c('ShareNetwork',{key:n.name,attrs:{"network":n.network,"url":_vm.url,"title":"Check out my infusion!"},on:{"open":_vm.openNetwork}},[_c('i',[_c('font-awesome-icon',{attrs:{"icon":['fab', n.icon],"size":"lg"}})],1),_c('span',[_vm._v(_vm._s(n.name))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }